import { render, staticRenderFns } from "./AdminDeliveriesScreen.vue?vue&type=template&id=3757300f&scoped=true&"
import script from "./AdminDeliveriesScreen.vue?vue&type=script&lang=js&"
export * from "./AdminDeliveriesScreen.vue?vue&type=script&lang=js&"
import style0 from "./AdminDeliveriesScreen.vue?vue&type=style&index=0&id=3757300f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3757300f",
  null
  
)

export default component.exports